import { Action } from 'redux';
import { BasketActionTypes } from '../basket.types';
import { ACTION_CREATOR_NAME } from 'helpers';
import { BasketCareKitAddonModel } from 'models/Basket';

export interface SaveLoadedCareKitsAction extends Action<BasketActionTypes.SAVE_LOADED_CARE_KITS> {
    loadedCareKits: BasketCareKitAddonModel[];
}


export const saveLoadedCareKits: (loadedCareKits: BasketCareKitAddonModel[]) => SaveLoadedCareKitsAction = (loadedCareKits: BasketCareKitAddonModel[]) => ({
    type: BasketActionTypes.SAVE_LOADED_CARE_KITS,
    loadedCareKits: loadedCareKits
});
saveLoadedCareKits[ACTION_CREATOR_NAME] = 'saveLoadedCareKits';